export default function () {
    console.log('auth-ssr')
}